var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUberWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "246px",
    height: "246px",
    viewBox: "0 0 246 246",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-111.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.856221,213 L111,213 C114.129059,147.85571 167.936865,96 233.856221,96 C301.787245,96 356.856221,151.068976 356.856221,219 C356.856221,286.931024 301.787245,342 233.856221,342 C168.274495,342 114.68057,290.674126 111.052066,226 L199.856221,226 L199.856221,250 C199.856221,252.761424 202.094797,255 204.856221,255 L264.856221,255 C267.617644,255 269.856221,252.761424 269.856221,250 L269.856221,190 C269.856221,187.238576 267.617644,185 264.856221,185 L204.856221,185 C202.094797,185 199.856221,187.238576 199.856221,190 L199.856221,213 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberWhite);
export default __webpack_public_path__ + "static/media/uberWhite.9193e1d2fdde978838c2af1f41da7d17.svg";
export { ForwardRef as ReactComponent };